import { render, staticRenderFns } from "./FirstImportOnboarding.vue?vue&type=template&id=04208138"
import script from "./FirstImportOnboarding.vue?vue&type=script&lang=ts"
export * from "./FirstImportOnboarding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports